<template>
  <div class="payback-wrapper">
    <el-dialog
      v-bind="dialogProps"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        v-loading="loading"
        ref="paybackForm"
        :model="formModel"
        label-width="120px"
        :rules="formRules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="回款类型:" prop="refundType">
              <el-select
                v-model="formModel.refundType"
                clearable
                style="width: 100%"
                placeholder="请选择回款类型"
              >
                <el-option
                  v-for="item in refundTypeList"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回款金额(元):" prop="refundAmount">
              <el-input
                placeholder="请输入回款金额"
                v-model="formModel.refundAmount"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="回款日期:" prop="refundDate">
              <el-date-picker
                style="width: 100%"
                placeholder="请选择回款日期"
                v-model="formModel.refundDate"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回款期数:" prop="refundInstallment">
              <el-input
                v-model="formModel.refundInstallment"
                type="number"
                placeholder="请输入回款期数"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customerName">
              <el-input v-model="formModel.customerName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务员:" prop="salesManName">
              <el-input v-model="formModel.salesManName" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户打款银行:" prop="customerPayBank">
              <el-input
                v-model="formModel.customerPayBank"
                maxlength="100"
                placeholder="请输入准确的银行名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户银行账号:" prop="customerPayAccount">
              <el-input
                v-model="formModel.customerPayAccount"
                placeholder="请输入客户银行账号"
                type="number"
                oninput="if(value.length > 30) value=value.slice(0, 30)"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="我方收款公司:" prop="myReceivableCompany">
              <el-select
                v-model="formModel.myReceivableCompany"
                clearable
                style="width: 100%"
                filterable
                placeholder="请选择我方收款公司"
                @change="handleChangeCompany"
              >
                <el-option
                  v-for="item in myReceivableCompanyList"
                  :key="item.myReceivableCompanyCode"
                  :label="item.myReceivableCompanyName"
                  :value="item.myReceivableCompanyCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我方收款银行:" prop="myReceivableBank">
              <el-select
                v-model="formModel.myReceivableBank"
                clearable
                style="width: 100%"
                filterable
                placeholder="请选择我方收款银行"
                @change="handleBankChange"
              >
                <el-option
                  v-for="item in myReceivableBankList"
                  :key="item.myReceivableBankId"
                  :label="item.myReceivableBankName"
                  :value="item.myReceivableBankId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="我方收款账号:" prop="myReceivableAccount">
              <el-select
                v-model="formModel.myReceivableAccount"
                clearable
                style="width: 100%"
                filterable
                placeholder="请选择我方收款账号"
              >
                <el-option
                  v-for="item in myReceivableAccountList"
                  :key="item.myReceivableAccountId"
                  :label="item.myReceivableAccountName"
                  :value="item.myReceivableAccountId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号:" prop="contractNumber" required>
              <el-input v-model="formModel.contractNumber" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="合同金额(元):" prop="contractAmount">
              <el-input v-model="formModel.contractAmount" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票编号:" prop="refundRecordId">
              <el-select
                v-model="formModel.refundRecordId"
                clearable
                style="width: 100%"
                filterable
                placeholder="请选择发票编号"
                @change="handleChangeInvoice"
              >
                <el-option
                  v-for="item in invoiceList"
                  :key="item.id"
                  :label="item.invoiceNo"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="开票金额:" prop="invoiceAmount">
              <el-input v-model="formModel.invoiceAmount" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票日期:" prop="invoiceDate">
              <el-input v-model="formModel.invoiceDate" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="最小预算单元:" prop="minimumBudgetUnit">
              <el-select
                v-model="formModel.minimumBudgetUnit"
                clearable
                style="width: 100%"
                filterable
                placeholder="请选择预算单元"
                @change="handleSettlementChange"
              >
                <el-option
                  v-for="item in minimumBudgetUnitList"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="一级结算部门:" prop="firstAccountDept">
              <el-input v-model="formModel.firstAccountDept" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="业务结算部门:" prop="businessAccountDept">
              <el-cascader
                style="width: 100%"
                v-model="formModel.businessAccountDept"
                :options="deptOptions"
                :props="{
                  children: 'childrenDept',
                  label: 'departmentName',
                  value: 'departmentId',
                }"
                filterable
                clearable
                @change="handleChangeDept"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注:" prop="remark">
              <el-input
                v-model="formModel.remark"
                type="textarea"
                :rows="5"
                maxlength="400"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="附件:" prop="files">
              <el-upload
                ref="upload"
                class="upload-demo"
                action="action"
                accept=".jpg,.jpeg,.png,.pdf,.bmp,.doc"
                :http-request="handleUpdate"
                :before-upload="beforeAvatarUpload"
                :on-success="handleOnSuccess"
                :file-list="uploadList"
                :limit="5"
                :on-exceed="handleExceed"
                :before-remove="handleRemove"
              >
                <crm-button :text="'上传'"></crm-button>
                <div
                  slot="tip"
                  class="el-upload__tip"
                  style="word-break: normal"
                >
                  说明:仅支持文件格式：jpg、png、bmp、pdf、word,文件大小不得超过20M
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="plain" @click="handleClose(true)">关闭</el-button>
          <el-button type="primary" @click="handleSubmit()">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const MODE = ['add', 'edit'];
const TITLE = ['新增回款记录', ' 编辑回款记录'];

import crmButton from '@/components/base/crmButton';
import services from '@/services/api/compact/index.js';
import { mapActions } from 'vuex';

export default {
  components: {
    crmButton,
  },
  props: {
    row: {},
  },
  data() {
    const checkAmountRule = (rule, value, callback) => {
      const reg = /^([1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/;
      if (!reg.test(value)) {
        callback(new Error('请输入最多两位小数的数字'));
      } else if (value > 999999999999.99) {
        callback(new Error('最多十二位数'));
      } else {
        callback();
      }
    };
    const checkCustomerBankName = (rule, value, callback) => {
      if (value) {
        const reg = /^[\u4E00-\u9FA5A-Za-z]+$/;
        if (!reg.test(value)) {
          callback(new Error('客户银行仅支持输入中英文'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const checkRefundInstallment = (rule, value, cb) => {
      const reg = /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$|^$/;
      if (!reg.test(value)) {
        cb(new Error('仅支持1000以内的正整数'));
      } else {
        cb();
      }
    };
    return {
      authority: null,
      loading: false,
      deptOptions: [],
      dialogProps: {
        visible: false,
        mode: null,
        title: null,
      },
      formRules: {
        refundType: [
          {
            required: true,
            message: '请选择回款类型',
            trigger: ['blur', 'change'],
          },
        ],
        refundAmount: [
          { required: true, message: '请输入回款金额', trigger: 'blur' },
          {
            required: true,
            validator: checkAmountRule.bind(this),
            trigger: ['change', 'blur'],
          },
        ],
        refundDate: [
          { required: false, message: '请选择回款时间', trigger: 'blur' },
        ],
        refundInstallment: [
          {
            required: false,
            validator: checkRefundInstallment,
            trigger: ['change'],
          },
        ],
        customerName: [
          {
            required: true,
            message: '请选择回款客户',
            trigger: ['blur', 'change'],
          },
        ],
        customerPayBank: [
          { required: false, message: '请输入客户打款银行', trigger: ['blur'] },
          {
            required: false,
            validator: checkCustomerBankName.bind(this),
            trigger: ['change', 'blur'],
          },
        ],
        customerPayAccount: [
          { required: false, message: '请输入客户银行账号', trigger: 'blur' },
        ],
        myReceivableBank: [
          {
            required: true,
            message: '请选择我方收款银行',
            trigger: ['blur', 'change'],
          },
        ],
        myReceivableAccount: [
          {
            required: true,
            message: '请选择我方收款银行账号',
            trigger: ['blur', 'change'],
          },
        ],
        myReceivableCompany: [
          {
            required: true,
            message: '请选择我方收款公司',
            trigger: ['blur', 'change'],
          },
        ],
        minimumBudgetUnit: [
          {
            required: true,
            message: '请选择最小预算单元',
            trigger: ['blur', 'change'],
          },
        ],
        firstAccountDept: [
          {
            required: false,
            message: '请根据预算单元获取结算部门',
            trigger: ['blur', 'change'],
          },
        ],
        businessAccountDept: [
          {
            required: true,
            message: '请选择业务结算部门',
            trigger: ['blur', 'change'],
          },
        ],
      },
      formModel: {
        refundType: null,
        refundAmount: null,
        refundDate: null,
        refundInstallment: '',
        customerName: null,
        customerId: null,
        salesManName: null,
        salesmanCode: null,
        customerPayBank: null,
        customerPayAccount: null,
        myReceivableCompany: null,
        myReceivableBank: null,
        myReceivableAccount: null,
        contractNumber: null,
        contractAmount: null,
        refundRecordId: null,
        invoiceAmount: null,
        invoiceDate: null,
        minimumBudgetUnit: null,
        firstAccountDept: null,
        businessAccountDept: [],
        teamId: null,
        remark: null,
        files: [],
      },
      userTeam: null,
      uploadList: [],
      refundTypeList: [],
      myReceivableBankList: [],
      myReceivableAccountList: [],
      myReceivableCompanyList: [],
      invoiceList: [],
      minimumBudgetUnitList: [],
    };
  },
  watch: {
    'dialogProps.mode': {
      async handler(val) {
        await this.handleInitData();
        if (val === 'edit') {
          this.$nextTick(() => {
            this.myReceivableBankList = this.myReceivableCompanyList.find(
              item =>
                item.myReceivableCompanyCode
                === this.formModel.myReceivableCompany,
            ).bankList;
            this.myReceivableAccountList = this.myReceivableBankList.find(
              item =>
                item.myReceivableBankId === this.formModel.myReceivableBank,
            ).accountList;
          });
        }
      },
    },
  },
  mounted() {
    this.handleGetRefundTypeList()
  },
  methods: {
    async handleInitData() {
      try {
        this.loading = true;
        if (!this.myReceivableCompanyList.length) {
          await this.handleGetBankInfo();
          await this.handleGetBudgetUnitInfo();
          await this.handleGetInvoice();
          await this.handleGetDept();
        } else {
          this.formModel.businessAccountDept = this.userTeam;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleGetInvoice() {
      const { data } = await services.apiGetInvoice({
        contractId: this.formModel.contractId,
      });
      this.invoiceList = data.data;
    },
    async handleGetDept() {
      const { data } = await services.apiGetAllDept();
      this.deptOptions = this.handleInitTreeData(data.data);
      const res = await services.apiGetUserDept();
      this.userTeam = res.data.departmentId;
      this.formModel.businessAccountDept = this.userTeam;
    },
    async handleGetBankInfo() {
      const { data } = await services.apiGetMyBankInfo();
      this.myReceivableCompanyList = data.data;
    },
    async handleGetBudgetUnitInfo() {
      const { data } = await services.apiGetBudgetUnit();
      this.minimumBudgetUnitList = data.data;
    },
    handleInitTreeData(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item.childrenDept.length === 0) {
            delete item.childrenDept;
          }
          this.handleInitTreeData(item.childrenDept);
        });
      }
      return arr;
    },
    handleChangeCompany(val) {
      if (val !== '') {
        this.myReceivableBankList = this.myReceivableCompanyList.find(
          item => item.myReceivableCompanyCode === val,
        ).bankList;
        this.formModel.myReceivableBank = null;
        this.formModel.myReceivableAccount = null;
      } else {
        this.myReceivableBankList = null;
        this.myReceivableAccountList = null;
        this.formModel.myReceivableBank = null;
        this.formModel.myReceivableAccount = null;
      }
    },
    handleBankChange(val) {
      if (val !== '') {
        this.myReceivableAccountList = this.myReceivableBankList.find(
          item => item.myReceivableBankId === val,
        ).accountList;
        this.formModel.myReceivableAccount = null;
      } else {
        this.myReceivableAccountList = null;
        this.formModel.myReceivableAccount = null;
      }
    },
    handleChangeInvoice(val) {
      if (val !== '') {
        const target = this.invoiceList.find(item => item.id === val);
        this.formModel.invoiceAmount = target.invoiceAmount;
        this.formModel.invoiceDate = target.invoiceDate;
      } else {
        this.formModel.invoiceAmount = null;
        this.formModel.invoiceDate = null;
      }
    },
    handleSettlementChange(val) {
      if (val !== '') {
        const target = this.minimumBudgetUnitList.find(
          item => item.uid === val,
        );
        this.formModel.firstAccountDept = target.settlementDeptName;
        this.formModel.firstAccountDeptId = target.settlementDeptId;
      }
    },
    handleChangeDept(val) {
      this.formModel.businessAccountDept = val[val.length - 1];
    },
    async handleUpdate(item) {
      // 上传
      const params = new FormData();
      params.append('file', item.file);
      params.append('fileName', item.file.name);
      try {
        const res = await services.apiUploadFile(params);
        this.$message.success('上传成功');
        this.formModel.files.push(res.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    beforeAvatarUpload(file) {
      // 检查文件大小 20M
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
        this.uploadList = [];
      }
      return isLt20M;
    },
    handleOnSuccess(response, file, fileList) {
      this.uploadList = fileList;
    },
    // eslint-disable-next-line consistent-return
    handleRemove(file, fileList) {
      const delIndex = this.uploadList.findIndex(item => item.uid === file.uid);
      // 删除
      if (file && file.status === 'success') {
        this.$confirm(`确定移除 ${file.name}？`)
          .then(() => {
            this.formModel.files.splice(delIndex, 1);
            this.uploadList.splice(delIndex, 1);
          })
          .catch((error) => {
            console.log(error);
            this.$message.info('取消操作');
          });
        return false;
      }
    },
    handleExceed() {
      this.$message.error('最多支持上传5个文件');
    },
    handleOpen() {
      this.formModel = Object.assign(this.formModel, {
        contractId: this.row.id,
        contractNumber: this.row.contractNo,
        contractAmount: this.row.contractAmount,
        customerName: this.row.customerName,
        customerId: this.row.customerId,
        salesmanCode: this.row.salesmanCode,
        salesManName: this.row.userName,
        teamId: this.row.teamId,
        businessAccountDept: this.userTeam,
      });
      this.dialogProps = {
        visible: true,
        mode: MODE[0],
        title: TITLE[0],
      };
    },

    handleEdit(row) {
      this.dialogProps = {
        visible: true,
        mode: MODE[1],
        title: TITLE[1],
      };
      this.$nextTick(() => {
        const {
          id,
          contractNo,
          refundTypeCode,
          myReceivableCompanyId,
          myReceivableBankId,
          myReceivableAccountId,
          minimumBudgetUnitId,
          businessAccountDeptId,
          fileList,
          salesmanName,
          salesmanCode,
          refundInstallment,
          ...rest
        } = row;
        this.formModel = Object.assign(this.formModel, rest, {
          id,
          contractNumber: contractNo,
          refundType: refundTypeCode,
          refundInstallment: refundInstallment === 0 ? '' : refundInstallment,
          myReceivableCompany: myReceivableCompanyId,
          myReceivableBank: myReceivableBankId,
          myReceivableAccount: myReceivableAccountId,
          minimumBudgetUnit: minimumBudgetUnitId,
          businessAccountDept: businessAccountDeptId,
          salesManName: salesmanName,
          salesmanCode,
          files: fileList.length > 0 ? fileList.map(item => item.id) : [],
        });
        fileList.forEach((item) => {
          this.uploadList.push({
            url: item.fileUrl,
            name: item.fileName,
          });
        });
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.paybackForm.validate();
        // this.handleClose()
        this.$confirm(
          '当前操作将提交回款申请至财务侧核对、确认，提交后不可撤回，是否继续？',
          '提交确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(async () => {
          if (this.dialogProps.mode === 'add') {
            await services.apiAddPayback({
              contractId: this.contractId,
              ...this.formModel,
            });
          } else {
            await services.apiEditPayback({
              contractId: this.contractId,
              ...this.formModel,
            });
          }
          this.$message.success('操作成功');
          this.$emit('handle-success-payback');
          this.handleClose();
        });
      } catch (error) {
        console.log(error);
      }
    },

    handleClose(isClick = false) {
      if (isClick) {
        this.$confirm(
          '当前操作将关闭该弹窗，编辑内容将丢失，是否继续？',
          '提交提醒',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(async () => {
          this.handleReset();
        });
      } else {
        this.handleReset();
      }
    },
    handleReset() {
      this.$refs.paybackForm.resetFields();
      this.formModel.businessAccountDept = [];
      this.formModel.files = [];
      this.uploadList = [];
      this.dialogProps = {
        visible: false,
        mode: MODE[0],
        title: TITLE[0],
      };
    },
    // 获取回款类型字典
    async handleGetRefundTypeList() {
      const { data } = await services.apiGetCategoryData({ code: 'category_refund_type' })
      this.refundTypeList = data.results
    },
  },
};
</script>

<style scoped lang="less"></style>
